<ng-container *transloco="let t">
@if (!isLoading) {
  <div id="consent-authorization-main" class="container">
    <div class="card">
      <div class="card-body fs-6 p-6 p-lg-15">
        @if (showEConsentVerbiage) {
          <div id="eConsentContainer" [innerHtml]="eBusinessConsentVerbiage | safeHtml"></div>
        }
      <div class="py-6">
        <h2 class="anchor fw-bolder mb-2" id="layout">{{ t('portal.eConsent.consentToDoBusiness') }}</h2>
        <div class="col-lg-12 fv-row mb-6">
          <div class="d-flex align-items-center mt-3">
            <label class="form-check form-check-inline form-check-solid me-5">
              <input class="form-check-input" required name="consentToDoBusinessCheckbox" #consent="ngModel"
                [ngClass]="{'is-invalid' : consent && consent.touched && consent.invalid}"
                [(ngModel)]="consentToDoBusiness" type="checkbox" value="1" />
              <span class="fw-bold ps-2 fs-6 required">{{ t('portal.eConsent.iWeConsent') }}</span>
              <div class="invalid-feedback">{{ t('portal.eConsent.consentRequired') }}</div>
            </label>
          </div>
        </div>
      </div>
      <div>
        <h2 class="anchor fw-bolder" id="layout">{{ t('portal.eConsent.consentToRunCredit') }}</h2>
        @if (showCreditAuthVerbiage) {
          <div id="creditCheckConsentContainer" [innerHtml]="creditCheckConsentVerbiage | safeHtml"></div>
        }
        <div class="col-lg-12 fv-row mb-6">
          <div class="d-flex align-items-center mt-3">
            <label class="form-check form-check-inline form-check-solid me-5">
              <input class="form-check-input" required name="consentToDoCreditCheckAuthorizationCheckbox"
                #consentForCreditCheck="ngModel"
                [ngClass]="{'is-invalid' : consentForCreditCheck && consentForCreditCheck.touched && consentForCreditCheck.invalid}"
                [(ngModel)]="consentToRunCredit" type="checkbox" value="1" />
              <span class="fw-bold ps-2 fs-6 required">{{ t('portal.eConsent.iWeConsent') }}</span>
              <div class="invalid-feedback">{{ t('portal.eConsent.consentRequired') }}</div>
            </label>
          </div>
        </div>
      </div>

      <div class="d-flex flex-stack justify-content-center pt-5 pb-5 px-20">
        <div class="mr-2">
          <button
            type="button"
            class="btn btn-lg btn-primary"
            (click)="onOkClicked()"
            [disabled]="!consentToRunCredit || !consentToDoBusiness">
            {{ t('portal.eConsent.agreeContinue') }}
          </button>
        </div>
      </div>

    </div>
  </div>
  </div>
}
@if (isLoading) {
  <loading-indicator [heading]="t('portal.eConsent.loadingHeading')"
    [message1]="t('portal.eConsent.loadingMessage1')"
    [message2]="t('portal.eConsent.loadingMessage2')">
  </loading-indicator>
}
</ng-container>
